import React from 'react';
import PropTypes from 'prop-types';
import Coverage from '../Steps/General/Coverage';
import { validateCoverageCode } from '../../utilities/package/packageUtils';
import Icon from '../Global/Icon';
import { getCoverageCodes } from '../../utilities/combined-common';

export const CompactPackage = ({ forProduct, userData, toolTip, initialValues }) => {
  const coverageCodes = getCoverageCodes(forProduct, userData);

  return (
    <ul className='coverage-level combined-coverage'>
      {coverageCodes.filter(coverageCode =>
        validateCoverageCode({ code: coverageCode }, initialValues, userData))
        .map((coverageCode) =>
          <li className="combined-coverage-text" key={coverageCode}>
            <div data-rh={toolTip}>
              <Icon {...{ icon: 'checkmark', fill: 'black' }} />
              <Coverage
                variant="compactButton"
                coverageCode={coverageCode}
                showDescription={false}
              />
            </div>
          </li>
        )}
    </ul>
  );
}

CompactPackage.defaultProps = {
  initialValues: {},
  toolTip: ""
}

CompactPackage.propTypes = {
  userData: PropTypes.object.isRequired,
  forProduct: PropTypes.string.isRequired,
  toolTip: PropTypes.string,
  initialValues: PropTypes.object,
}